module.exports = __webpack_public_path__ + "static/corellon-larethian-takes-the-eye-of-gruumsh-DND3_FnP-7b54f9cc6d104642db5a9694e8c28f78.jpg";